import { ref } from 'vue'
import { projectFirestore } from '../firebase/config'

const getMember = (id) => {

  const member = ref(null)
  const error = ref(null)

  const load = async () => {
    try {
      let res = await projectFirestore.collection('members').doc(id).get()
      // console.log(res)
      // console.log(res.data)

      if (!res.exists) {
        throw Error('エラー: IDを確認してください。')
      }
      member.value = { ...res.data(), id: res.id }
      console.log(member.value)
    }
    catch(err) {
      error.value = err.message
    }
  }

  return { member, error, load } 
}

export default getMember